export const SET_TIMESHEET_LOADING = "SET_TIMESHEET_LOADING";
export const SET_TIMESHEET = "SET_TIMESHEET";
export const SET_PAYROLL_TIMECODE = "SET_PAYROLL_TIMECODE";

export const GET_TIMECARD_SETTINGS = "GET_TIMECARD_SETTINGS";
export const GET_TIMECARD_SETTINGS_LOADING = "GET_TIMECARD_SETTINGS_LOADING";
